import { ForkLiftJobService } from '@gtpl/shared-services/warehouse-management';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { SoakingAdapter } from './dto/soaking.adapter';
import { SoakingController } from './soaking.controller';
import { SoakingRepository } from './soaking.repository';
import { SoakingService } from './soaking.service';


@Module({
  imports: [
    TypeOrmModule.forFeature([SoakingRepository]),
  ],
  controllers: [SoakingController],
  providers: [SoakingService,ApplicationExceptionHandler,SoakingAdapter,ForkLiftJobService]
})
export class SoakingModule {}

